export default class SourceTextCache {

    private text: Map<number, Map<number, string>> = new Map();

    public putVerse(verseIndex: number, text: Map<number, string>): void {
        // Collapse multiple spaces into a single space.
        text.forEach((value, key, map) => map.set(key, value.replace(/ {2,}/g, ' ')));
        this.text.set(verseIndex, text);
    }

    public hasVerse(verseIndex: number): boolean {
        return this.text.has(verseIndex);
    }

    public getText(verseIndex: number, sourceIndex: number): string | undefined {
        const verse = this.text.get(verseIndex);
        if (verse === undefined) {
            throw new Error('Verse not cached: ' + verseIndex);
        }
        return verse.get(sourceIndex);
    }
}
